import PromisePool from "@supercharge/promise-pool";
import { generateSubscores } from "../../../util/generators/generateSubscores";

/**
 * convert dyslexia report data into array of parent letter metadata
 * @param {*} report dyslexia report data
 * @param {*} cutoffs 
 * @returns 
 */
export default async function getParentLetterData(report, cutoffs) {
  // filter to students who are at risk for dyslexia
  const reportRows = Array.from(report.scores.values()).filter(row => row.highestScore > cutoffs.MEDIUM_RISK);
  const { results } = await PromisePool.for(reportRows).process(getParentLetterDataForStudent);
  return results;
}

async function getParentLetterDataForStudent(reportRow) {
  const {studentId} = reportRow;
  reportRow.subscores = await generateSubscores(studentId);
  return reportRow;
}